<template>
    <div>
        <tab name="3"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最新日期的" :value="0"></el-option>
                        <el-option label="优先展示实际收入最多的" :value="1"></el-option>
                        <el-option label="优先展示总订单数最多的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="exportData" :loading="exportDataLoading" style="min-width: 110px;">导出</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="timeStr" label="日期" :min-width="150"></el-table-column>
                <el-table-column prop="userName" label="艺人"></el-table-column>
                <el-table-column prop="amount" label="实际收入" :min-width="150"></el-table-column>
                <el-table-column prop="orderNum" label="总订单数" :min-width="150"></el-table-column>
                <el-table-column prop="totalNum" label="售票数" :min-width="150"></el-table-column>
                <el-table-column prop="activityNum" label="演出数" :min-width="150"></el-table-column>
                <el-table-column prop="discounts" label="优惠金额" :min-width="150"></el-table-column>
                <el-table-column prop="djAmount" label="独家演出实际收入" :min-width="150"></el-table-column>
                <el-table-column prop="djOrderNum" label="独家演出订单数" :min-width="150"></el-table-column>
                <el-table-column prop="djTotalNum" label="独家演出售票数" :min-width="150"></el-table-column>
                <el-table-column prop="djActivityNum" label="独家演出数" :min-width="150"></el-table-column>
                <el-table-column prop="djDiscounts" label="独家演出优惠金额" :min-width="150"></el-table-column>
                <el-table-column prop="tzAmount" label="投资演出实际收入" :min-width="150"></el-table-column>
                <el-table-column prop="tzOrderNum" label="投资演出订单数" :min-width="150"></el-table-column>
                <el-table-column prop="tzTotalNum" label="投资演出售票数" :min-width="150"></el-table-column>
                <el-table-column prop="tzActivityNum" label="投资演出数" :min-width="150"></el-table-column>
                <el-table-column prop="tzDiscounts" label="投资演出优惠金额" :min-width="150"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="pageSizeChange"
                @current-change="pageNoChange"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';
import {downloadFileTmp} from '@/assets/js/commonApi.js';

export default {
    components:{Tab},
    data(){
        this.defaultParams = {
            sort: 0,
            pageNo: 1,
            pageSize: this.$pageSizes[0]
        };

        return{
            data: null,
            dataList: null,
            params: {...this.defaultParams},
            listLoading: false,
            filter: null,
            exportDataLoading: false  
        }
    },
    created() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            const {artistId, timeStart, timeEnd} = this.$route.query;
            const {...params} = this.params;

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/artist/data_list',
                method: 'post',
                data: {...params, artistId, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];

            this.filter = {...params, artistId, timeStart, timeEnd};
        },
         //选择pageSize
        pageSizeChange() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        pageNoChange() {
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {...this.defaultParams};
            this.getDataList();
        },
        // 导出
        async exportData() {
            const {filter} = this;

            if(!filter) {
                return this.$message.error('没有可以操作的数据');
            }

            this.exportDataLoading = true;

            const res = await this.$request({
                url:'/sales/artist/detail/export',
                method: 'post',
                data: filter,
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.exportDataLoading = false;
            });

            const{state, msg, result} = res.data;
            
            if(state !== '1') {
                return this.$message.error(msg || '下载失败');
            }

            downloadFileTmp(result.url, '艺人销售 - 日期明细.xlsx');
        }
    }
}
</script>